import { Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';

export const AddAddressDiv = styled('div')({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  padding: '16px',
  cursor: 'pointer',
});

export const AddAddressIconButton = styled(IconButton)({
  padding: '0',
  width: '24px',
  height: '24px',
  color: '#0A7ABE',
});

export const AddAddressTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0.16px',
  color: '#0A7ABE',
});
